import { render, staticRenderFns } from "./MetricList.vue?vue&type=template&id=3caebae8"
import script from "./MetricList.vue?vue&type=script&lang=js"
export * from "./MetricList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports